import {injectable} from 'inversify';

import {CurrencyModel} from './Currency.model';

@injectable()
export class CurrencyFactory {
  create(type: CurrencyModel.Type): CurrencyModel {
    return new CurrencyModel(type);
  }
}
